import { LottieComponentProps } from "lottie-react";
import LottieComponent from "./lottieComponent";
import animationdata from "@/images/CloverleafLogo.json";

const CloverleafLoading = (
  props: Omit<LottieComponentProps, "animationData">,
) => {
  return <LottieComponent {...props} animationData={animationdata} />;
};

export default CloverleafLoading;
